import KlaviyoTrackingService from "analytics/klaviyo/klaviyoEvents";
import sendMessageApi from "api/contact/sendMessageApi";
import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import {
  SubmitInput, TitleContainer,
} from "component/design-system/shared-styles/SharedStyle";
import StoresLocation from "container/in-store-pickup/stores-location.component";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState, memo } from "react";
import Select from "react-select";
import openLiveChat from "util/chat-widget/open-live-chat";
import PAButton from "../../component/design-system/buttons/PAButton";
import LandingPageBanner from "../../component/landing-page/LandingPageBanner";
import OrganizationMetaHeader from "../../component/meta-header/OrganizationMetaHeader";
import PageContainer from "../../modules/components/PageContainer";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import { scrollToTop } from "../../util/scroll-helper";
import styles from "./contactUs.module.scss";

function ContactUs(props: IGenericCmsPage) {
  const response = props.actualResponse.landingPage;
  const { headers } = response;
  const { contentIds } = response.links;
  const pickupLocations = contentIds && contentIds
    .find((eachContent: any) => eachContent?.uiDetails?.uiType === "JSON")?.uiDetails.content;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [department, setDepartment] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { t } = useTranslation(["static-pages", "common"]);
  const { locale } = useRouter();
  const bannerPrefix = `/cms/pubicImages/images/${locale === "fr" ? "fr-" : ""}`;
  const contactUsOptions = [
    { value: "general", label: t("General Enquiries") },
    { value: "sales", label: t("Sales") },
    { value: "returns", label: t("Returns") },
    { value: "shipping", label: t("Shipping", { ns: "common" }) },
    { value: "payments", label: t("Payments") },
  ];
  useEffect(() => {
    scrollToTop();
  }, []);

  const handleSubmit = (evt: any) => {
    evt.preventDefault();
    if (
      name.length > 0
      && email.length > 0
      && phone.length > 0
      && department && department.value.length > 0
      && subject.length > 0
      && message.length > 0
    ) {
      setShowError(false);

      KlaviyoTrackingService.identifyKlaviyoUser(email);

      sendMessageApi({
        name,
        email,
        phone,
        department: department.value,
        subject,
        message,
      }).then(() => {
        setName("");
        setEmail("");
        setPhone("");
        setDepartment("");
        setSubject("");
        setMessage("");
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
      });
    } else {
      setShowError(true);
      setShowSuccess(false);
    }
  };

  function handleChat() {
    openLiveChat();
  }

  return (
    <PageContainer>

      <OrganizationMetaHeader />

      <LandingPageBanner
        className="m-t-10"
        style={{ height: "auto" }}
        bannerImages={{
          mobileImage: getRelativeImagePath(`${bannerPrefix}contact-us-for-car-parts-m.webp`),
          desktopImage: getRelativeImagePath(`${bannerPrefix}contact-us-for-car-parts.webp`),
        }}
        {...{ width: 1340, height: 397 }}
        alt={t("contact parts avatar")}
      />

      <div
        className="d-flex"
        style={{ justifyContent: "center", marginTop: "calc(2 * var(--safari-root-font, 10px))" }}
      >

        <h1>{headers.h1}</h1>
      </div>

      <div className="row m-lr-0">

        <div className="col-md-8 p-lr-0">

          <div className={`d-flex ${styles.mt_2} ${styles.each_section} ${styles.left_section} align-items-center`}>

            <div className={styles.grid}>

              <TitleContainer className={styles.subheading}>
                {t("Live Chat", { ns: "common" })}

                <i
                  className={`fa fa-comments-o ${styles.fa_styling}`}
                  aria-hidden="true"
                  style={{ float: "right" }}
                />
              </TitleContainer>

              <div
                style={{ width: "100%", textAlign: "center" }}
                className={styles.mb_2}
              >

                <PAButton onClick={() => handleChat()}>
                  {" "}
                  {t("CHAT NOW")}
                </PAButton>
              </div>

            </div>

            <div className={styles.grid}>

              <TitleContainer className={styles.subheading}>
                {t("Email", { ns: "common" })}

                <i
                  className={`fa fa-envelope ${styles.fa_styling}`}
                  aria-hidden="true"
                  style={{ float: "right" }}
                />
              </TitleContainer>

              <div className={styles.mb_1}>

                <span className={styles.hours}>
                  {`${t("General")}:`}
                  {" "}
                </span>

                <span className={styles.days}>

                  <a className="text-left" href="mailto:sales@partsavatar.ca">
                    sales@partsavatar.ca
                  </a>
                </span>
              </div>

              <div className={styles.mb_1}>

                <span className={styles.hours}>
                  {`${t("Sales") }:`}
                  {" "}
                </span>

                <span className={styles.days}>

                  <a className="text-left" href="mailto:sales@partsavatar.ca">
                    sales@partsavatar.ca
                  </a>
                </span>
              </div>

              <div className={styles.mb_1}>

                <span className={styles.hours}>{`${t("Shipping")}:`}</span>

                <span className={styles.days}>

                  <a
                    className="text-left"
                    href="mailto:shipping@partsavatar.ca"
                  >
                    shipping@partsavatar.ca
                  </a>
                  {" "}
                </span>
              </div>

              <div className={styles.mb_1}>

                <span className={styles.hours}>
                  {`${t("Returns") }:`}
                  {" "}
                </span>

                <span className={styles.days}>

                  <a className="text-left" href="mailto:returns@partsavatar.ca">
                    returns@partsavatar.ca
                  </a>
                  {" "}
                </span>
              </div>

              <div className={styles.mb_1}>

                <span className={styles.hours}>{`${t("Payments")}:`}</span>

                <span className={styles.days}>

                  <a
                    className="text-left"
                    href="mailto:payments@partsavatar.ca"
                  >
                    payments@partsavatar.ca
                  </a>
                  {" "}
                </span>
              </div>
            </div>

            <div className={styles.grid}>

              <TitleContainer className={styles.subheading}>
                {t("FAQ")}

                <i
                  className={`fa fa-question-circle ${styles.fa_styling}`}
                  aria-hidden="true"
                  style={{ float: "right" }}
                />
              </TitleContainer>

              <div className={styles.mb_1}>

                <Link href="/questions-about-autoparts">
                  {t("FAQ Page")}
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4 p-lr-0">

          <div className={`d-flex ${styles.mt_2} ${styles.each_section} ${styles.right_section} align-items-center`}>

            <div className={`${styles.subheading} ${styles.mb_2}`} style={{ paddingTop: "18px", maxWidth: "calc(50 * var(--safari-root-font, 10px))" }}>
              {t("General Inquiries")}
            </div>

            <form
              onSubmit={handleSubmit}
              className={styles.formStyling}
            >

              <input
                className={`${styles.form_control} ${styles.mb_1}`}
                type="text"
                placeholder={`${t("First Name")}*`}
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <input
                className={`${styles.form_control} ${styles.mb_1}`}
                type="text"
                inputMode="email"
                placeholder={`${t("Email", { ns: "common" })}*`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <input
                className={`${styles.form_control} ${styles.mb_1}`}
                type="text"
                placeholder={`${t("Phone Number")}*`}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />

              <div className={styles.select_styles}>
                <Select
                  className={styles.mb_1}
                  value={department}
                  searchable={false}
                  clearable={false}
                  options={contactUsOptions}
                  placeholder={`${t("Select a Department")}*`}
                  onChange={(selectedValue: any) => setDepartment(selectedValue)}
                  classNamePrefix="react-select"
                />
              </div>

              <input
                className={`${styles.form_control} ${styles.mb_1}`}
                type="text"
                placeholder={`${t("Subject")}*`}
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />

              <textarea
                className={`${styles.form_control} ${styles.mb_1}`}
                style={{ height: "auto" }}
                name="message"
                placeholder={`${t("Your Message")}*`}
                rows={4}
                onChange={(e) => setMessage(e.target.value)}
                required
              />

              <SubmitInput type="submit" value={t("SUBMIT")} />
              {showError && (
                <span style={{ color: "#f44336", paddingTop: "calc(1 * var(--safari-root-font, 10px))" }}>
                  {`${t("Enter data for required fields") }.`}
                </span>
              )}
              {showSuccess && (
                <span style={{ color: "#4caf50", paddingTop: "calc(1 * var(--safari-root-font, 10px))" }}>
                  {`${t("Thanks for the comment")}.`}
                </span>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className={`${styles.mt_2} ${styles.each_section} d-flex justify-content-around flex-wrap`}>
        <StoresLocation pickupLocations={pickupLocations} />
      </div>
    </PageContainer>
  );
}

export default memo(ContactUs);
